export const DOBOX_BULK_I18N_KEYS = {
  MARKED_DONE: 'doBox.bulkActions.toast.markedDone',
  MARKED_UNDONE: 'doBox.bulkActions.toast.markedUndone',
  DELETED: 'doBox.bulkActions.toast.deleted',
  MOVED: 'doBox.bulkActions.toast.moved',
  PRIORITY_SET: 'doBox.bulkActions.toast.priority',
  DELETE_CONFIRM_TITLE: 'doBox.bulkActions.deleteConfirmTitle',
  DELETE_CONFIRM_BODY: 'doBox.bulkActions.deleteConfirmBody',
  SELECTED_COUNT: 'doBox.bulkActions.selectedCount',
  SELECTED_LABEL: 'doBox.bulkActions.selectedLabel',
  SELECT_ALL_TASKS: 'doBox.bulkActions.selectAllTasks',
  SELECT_ALL_SUGGESTIONS: 'doBox.bulkActions.selectAllSuggestions',
  BLOCKED_SUGGESTION: 'doBox.bulkActions.blockedSuggestion',
  BLOCKED_TASK: 'doBox.bulkActions.blockedTask',
  CLEAR_ALL: 'doBox.bulkActions.clearAll',
  MARK_DONE: 'doBox.bulkActions.markDone',
  MARK_UNDONE: 'doBox.bulkActions.markUndone',
  MOVE: 'doBox.bulkActions.move',
  PRIORITY: 'doBox.bulkActions.priority',
  DELETE: 'doBox.bulkActions.delete',
  CLOSE_SELECTION: 'doBox.bulkActions.closeSelection',
  PRIORITY_LOADING: 'doBox.bulkActions.toast.priorityLoading',
  PRIORITY_ERROR: 'doBox.bulkActions.toast.priorityError',
  MOVE_LOADING: 'doBox.bulkActions.toast.moveLoading',
  MOVE_ERROR: 'doBox.bulkActions.toast.moveError',
  ACCEPT_SUGGESTION: 'doBox.bulkActions.acceptSuggestion',
  REJECT_SUGGESTION: 'doBox.bulkActions.rejectSuggestion',
  ACCEPT_LOADING: 'doBox.bulkActions.toast.acceptingSuggestions',
  ACCEPT_SUCCESS: 'doBox.bulkActions.toast.suggestionsAccepted',
  ACCEPT_ERROR: 'doBox.bulkActions.toast.acceptSuggestionsError',
  MOVE_GROUP_SECTION: 'doBox.bulkActions.moveTaskGroupSection',
  MOVE_SUBGROUP_SECTION: 'doBox.bulkActions.moveSubgroupSection',
  NO_SUBGROUP: 'doBox.bulkActions.noSubgroup',
  MOVED_TO_SUBGROUP: 'doBox.bulkActions.toast.movedToSubgroup',
  MOVED_OUT_OF_SUBGROUP: 'doBox.bulkActions.toast.movedOutOfSubgroup',
} as const;
